import instance from "./axios.base";

const getNationalities = async () => {
  const res = await instance.get("/nationality");
  return res.data;
};

export { getNationalities };
